'use client';
import { useRemoteMedia } from './useRemoteMedia';

export const useRemoteVideo = (props: {
  peerId: string;
  onClose?: (reason?: {
    code: number;
    tag: string;
    message: string;
  }) => void;
  onPlayable?: (data: {
    stream: MediaStream;
    track: MediaStreamTrack;
    label: 'video';
  }) => void;
}) => {
  const { state, track, stream } = useRemoteMedia({
    label: 'video',
    peerId: props.peerId,
    onClose: props.onClose,
    onPlayable: (data) => {
      props.onPlayable?.({
        label: 'video',
        track: data.track,
        stream: data.stream,
      });
    },
  });

  const isVideoOn = !!stream;

  return {
    state,
    track,
    stream,
    isVideoOn,
  };
};
